"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.form.back': 'Indietro',
    'profession.form.name.label': 'Nome',
    'profession.form.name.placeholder': 'Nome della professione',
    'profession.form.branch.label': 'Settore',
    'profession.form.branch.placeholder': 'Seleziona settore',
    'profession.form.description.label': 'Descrizione',
    'profession.form.description.placeholder': 'Inserisci la descrizione della professione',
    'profession.form.common.label': 'Comune',
    'profession.form.image.label': 'Immagine',
    'profession.form.knowledge.label': 'Voci di Conoscenza',
    'profession.form.knowledge.title': 'Voci di Conoscenza',
    'profession.form.steps.title': 'Passi',
    'profession.form.steps.label': 'Seleziona Passi',
    'profession.form.submit.label': 'Invia',
    'profession.form.active.label': 'Attivo',
    'profession.form.knowledge.placeholder': 'Cerca voci di conoscenza...',
    'profession.form.branches.load.error': 'Errore nel caricamento dei settori',
    'profession.form.steps.load.error': 'Errore nel caricamento dei passi',
    'profession.form.load.error': 'Errore nel caricamento della professione',
    'profession.form.update.success': 'Professione aggiornata con successo',
    'profession.form.action.success': 'Professione',
    'profession.form.action.error': 'La professione non è riuscita ad essere',
    'profession.form.action.failed': 'Errore nel',
    'profession.form.update': 'aggiornare',
    'profession.form.create': 'creare',
};
